import { useTabStore } from "~/stores";
import { SEARCH_TABS } from "~/types/search.types";
import KeywordCompanyList from "./KeywordSearch/KeywordCompanyList";
import KeywordTopicList from "./KeywordSearch/KeywordTopicList";

const ViewSearch = () => {
    const activeTab = useTabStore(state => state.tab);
    const isTopicSearch = activeTab?.key !== SEARCH_TABS.FULL_DOCUMENTS;

    return (
        <div className="p-2">{isTopicSearch ? <KeywordTopicList /> : <KeywordCompanyList />}</div>
    );
};

export default ViewSearch;
